/**
 * Image-type framework params (MM_TIMG, MM_BIMG, …) are often a full
 * IContentElementImage — object or JSON string — not a bare URL.
 * Domain rewrite must see only the URL, or it concatenates `"scale":…`
 * onto the src (broken img requests).
 */
export const unwrapAssetUrl = (value: any): string | undefined => {
    if (value == null || value === '') {
        return undefined;
    }
    if (typeof value === 'object') {
        return unwrapAssetUrl(value.url);
    }
    if (typeof value !== 'string') {
        return undefined;
    }
    const trimmed = value.trim();
    if (trimmed.startsWith('{')) {
        try {
            const parsed = JSON.parse(trimmed);
            if (parsed && typeof parsed === 'object') {
                return unwrapAssetUrl(parsed);
            }
        } catch {
            // keep treating it as a URL
        }
    }
    const quoteIdx = trimmed.indexOf('"');
    if (quoteIdx > 8 && /https?:\/\//.test(trimmed.slice(0, quoteIdx))) {
        return trimmed.slice(0, quoteIdx);
    }
    return trimmed;
};

export const replaceS3Domains = (url: string): string => {
    if (!url || typeof url !== "string") {
        return url
    }

    const unwrapped = unwrapAssetUrl(url) || url;

    const domainsList = {
        'authoring.mathproficiencytest.ca': 'authoring',
        'd3azfb2wuqle4e.cloudfront.net': 'authoring',
        'storage.mathproficiencytest.ca': 'storage',
        'd3c1mbjtikq6ue.cloudfront.net': 'storage'
    }
    const replacementDomain = 'https://eqao.vretta.com';
    
    let newUrl = unwrapped;
    
    Object.keys(domainsList).forEach(domain => {
        if(unwrapped.includes(domain)){
            const urlSegArr = unwrapped.split('/')
            const subdirectoryIdx = urlSegArr.findIndex(seg => seg.includes(domain)) + 1
            if(subdirectoryIdx){
                newUrl = [replacementDomain, domainsList[domain]].concat(urlSegArr.slice(subdirectoryIdx)).join('/')
            }
        }
    });

    return unwrapAssetUrl(newUrl) || newUrl;
}

/**
 * Convert an array of header (index 0) and values (rest of indexes) to an array of key value objects.
 * [["connection_id", "uid"], ['IxdRufxvYosCGVw=', 5197203]] -> [{connection_id: "IxdRufxvYosCGVw=", uid: 5197203}]
 * @param {array} data 
 * @returns {array} array of key value object(s)
 */
export const convertHeaderArrayIntoObjects = (data: any[][]):any[] => {
    if (!Array.isArray(data[0])) { // object or undefined return false
        return data
    }
    const [headers, ...datas] = data;
    const dataObj = datas.map(row => {
        const obj = {}
        headers.forEach((key, index) => {
            obj[key] = row[index]
        })
        return obj
    })
    return dataObj
}
